/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {appInit as ɵc} from './app-init';
export {ProxyCmp as ɵb} from './directives/proxies-utils';
export {DECLARATIONS as ɵa} from './super-tabs.module';